<template>
<div class="container">
  <div class="animation-container">
    <div class="circle"></div>
    <svg class="lock"
         viewBox="0 0 336 421"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
            <path
              class="down"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.4 155C14.5593 155 10.6389 155 7.64413 156.526C5.00987 157.868 2.86814 160.01 1.52591 162.644C7.15256e-07 165.639 0 169.559 0 177.4V398.6C0 406.441 7.15256e-07 410.361 1.52591 413.356C2.86814 415.99 5.00987 418.132 7.64413 419.474C10.6389 421 14.5593 421 22.4 421H313.6C321.441 421 325.361 421 328.356 419.474C330.99 418.132 333.132 415.99 334.474 413.356C336 410.361 336 406.441 336 398.6V177.4C336 169.559 336 165.639 334.474 162.644C333.132 160.01 330.99 157.868 328.356 156.526C325.361 155 321.441 155 313.6 155L22.4 155ZM206.5 267.7C206.5 281.608 199.126 293.793 188.074 300.559L191.112 333.982C191.857 342.181 185.402 349.25 177.169 349.25H158.83C150.598 349.25 144.143 342.181 144.888 333.982L147.926 300.559C136.874 293.793 129.5 281.608 129.5 267.7C129.5 246.437 146.737 229.2 168 229.2C189.263 229.2 206.5 246.437 206.5 267.7Z"
              fill="#6D7782"
            />
            <path
              class="up"
              d="M167.5 0C97.0837 0 50 56.5752 50 126.364V225H94.8352V126.364C94.8352 81.1164 121.845 44.4358 167.5 44.4358C213.155 44.4358 240.165 81.1164 240.165 126.364V154.966H285V126.364C285 56.5752 237.916 0 167.5 0Z"
              fill="#6D7782"
            />
          </svg>
  </div>
  <div class="header">
    <img src="/img/briskly.svg" alt="" />
  </div>
  <div class="start-new">
    <div class="start-new-first">Поднесите штрихкод товара к сканеру</div>
    <img src="/img/barcode-scanner-icon.svg" class="start-new-img" />
    <div class="start-new-second">Сканер расположен справа вверху</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Start',
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.animation();
    clearInterval(this.$store.state.timeout);
    let elem = this;
    this.$store.state.timeout = setInterval(function() {
      elem.$store.state.timeSpent += 1000;
      if (elem.$store.state.timeSpent > 200000) {
        clearInterval(elem.$store.state.timeout);
        elem.$router.push('/');
      }
    }, 1000);
  },
  methods: {
    animation() {
      let loading = false;

      const container = document.querySelector('.animation-container');
      const lock = document.querySelector('.lock');
      const circle = document.querySelector('.circle');
      const up = lock.querySelector('.up');
      const down = lock.querySelector('.down');

      container.addEventListener('animationend', animationEndHandler);

      start();

      function animationEndHandler({ animationName }) {
        if (animationName.indexOf('unlock-container') !== -1) {
          loading = false;
          container.style.zIndex = '-999';
        }
      }

      function start() {
        if (loading) return;
        loading = true;

        up.style.animationPlayState = 'running';
        down.style.animationPlayState = 'running';
        circle.style.animationPlayState = 'running';

        const after = () => {
          up.removeEventListener('animationend', after);
          lock.style.animationPlayState = 'running';
          container.style.animationPlayState = 'running';
        };

        up.addEventListener('animationend', after);
      }
    },
  },
};
</script>

<style scoped>
@keyframes unlock-circle {
  100% {
    width: 1500px;
    height: 1500px;
  }
}

@keyframes unlock-up {
  100% {
    transform: scale(0.5) translateY(-34px);
  }
}

@keyframes unlock-down {
  100% {
    transform: scale(0.5) translateY(34px);
  }
}

@keyframes unlock-lock {
  100% {
    transform: scale(0.2);
  }
}

@keyframes unlock-container {
  100% {
    opacity: 0;
  }
}

/* body {
  padding: 0;
  margin: 0;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
} */

.animation-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #33393f;
  animation: unlock-container 0.5s ease 1 alternate;
  animation-fill-mode: forwards;
  animation-play-state: paused;
  animation-delay: 0.3s;
  opacity: 1;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}

.lock {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  transform: scale(1);
  animation: unlock-lock 0.5s 1 alternate ease;
  animation-fill-mode: forwards;
  animation-play-state: paused;
  /* animation-delay: 0.3s; */
}

.up {
  animation: unlock-up cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform: scale(0.5);
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}

.down {
  transform: scale(0.5);
  animation: unlock-down cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}

.circle {
  position: absolute;
  z-index: 1;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #33393f;
  animation: unlock-circle cubic-bezier(0.51, 0.75, 1, 0.42) 0.5s alternate 1;
  animation-fill-mode: forwards;
  transform-origin: center;
  animation-play-state: paused;
  animation-delay: 0.3s;
}
.header {
  display: block;
  text-align: center;
  margin-top: 54px;
  height: 148px;
  padding-top: 45px;
}
.header img {
  width: 160px;
  text-align: center;
  display: block;
  margin: 0 auto;
}
.content {
  /* z-index: 2022; */
}

.start-new-first {
  position: absolute;
  left: 20.83%;
  right: 21.11%;
  top: 29.91%;
  bottom: 64.84%;

  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */

  display: flex;
  align-items: center;
  text-align: center;

  color: #ffffff;
}
.start-new-second {
  position: absolute;
  left: 28.06%;
  right: 28.33%;
  top: 75.47%;
  bottom: 17.66%;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  /* or 22px */

  display: flex;
  align-items: center;
  text-align: center;

  /* Gray 6 */

  color: #f2f2f2;
}
.start-new-img {
  margin: 0px auto;
  width: 200px;
  height: 200px;
  margin: 270px 0px 0px 78px;
}
</style>
